<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="13.02" height="13.997" viewBox="0 0 13.02 13.997">
		<g id="linkedin--network-linkedin-professional" transform="translate(-0.49)">
			<path
				id="Vector"
				d="M3.574,1.767A1.316,1.316,0,0,1,2.287,3.093,1.346,1.346,0,0,1,.99,1.767,1.326,1.326,0,0,1,2.287.5,1.316,1.316,0,0,1,3.574,1.767ZM1.129,5.449c0-.762.485-.643,1.158-.643s1.148-.119,1.148.643v7.424c0,.772-.485.614-1.148.614s-1.158.158-1.158-.614Z"
				fill="none"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1"
			/>
			<path
				id="Vector_2"
				d="M5.435,5.449c0-.426.158-.584.406-.633a13.117,13.117,0,0,1,1.4,0c.3,0,.416.485.406.851a2.485,2.485,0,0,1,2.217-.99,2.97,2.97,0,0,1,3.148,3.1v5.068c0,.772-.475.614-1.148.614s-1.148.158-1.148-.614V8.884a1.425,1.425,0,0,0-1.5-1.544A1.435,1.435,0,0,0,7.741,8.914v3.959c0,.772-.485.614-1.158.614s-1.148.158-1.148-.614V5.449Z"
				fill="none"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'linkedinIcon',
	data() {
		return {};
	},
	props: {
		color: {
			type: String,
			default: '#fff',
		},
	},
};
</script>

<style lang="scss"></style>
